import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import type { VariantProps } from "class-variance-authority";
import type * as React from "react";
import { cn } from "../../utils/cn";
import { toggleGroupItemClasses, toggleGroupRootVariants } from "./toggle-group.variants";

type ToggleGroupProps = React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Root> &
  VariantProps<typeof toggleGroupRootVariants> & {
    ref?: React.RefObject<React.ElementRef<typeof ToggleGroupPrimitive.Root> | null>;
  };

function ToggleGroup({ ref, className, variant = "default", ...props }: ToggleGroupProps) {
  return (
    <ToggleGroupPrimitive.Root
      ref={ref}
      data-variant={variant}
      className={cn(toggleGroupRootVariants({ variant }), className)}
      {...props}
    />
  );
}
ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;

type ToggleGroupItemProps = React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Item> & {
  ref?: React.RefObject<React.ElementRef<typeof ToggleGroupPrimitive.Item> | null>;
};

function ToggleGroupItem({ ref, className, ...props }: ToggleGroupItemProps) {
  return <ToggleGroupPrimitive.Item ref={ref} className={cn(toggleGroupItemClasses, className)} {...props} />;
}
ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;

export { ToggleGroup, ToggleGroupItem };
